import type { Player } from '../index.h'

import { ChromecastSessionManager } from './ChromecastSessionManager'

export { ChromecastSessionManager }

export function createSessionManager(player: Player) {
  if (!player.chromecastSessionManager)
    player.chromecastSessionManager = new ChromecastSessionManager(player)

  return player.chromecastSessionManager
}
